import { Alert, Chip, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

/**
 * Red "considered but invalid" banner for a direct concept-id upload: makes the
 * skipped entries the chat reports visible in the panel too. Renders nothing
 * when the upload was clean.
 */
export const SkippedEntriesNotice = ({ values }: { values: string[] }) => {
  const { formatMessage } = useIntl();
  if (values.length === 0) return null;
  return (
    <Alert severity="error" variant="outlined" data-testid="cg-preview-skipped-entries">
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {formatMessage(
          { id: 'epiChat.conceptGroupPreview.skipped.title' },
          { count: values.length }
        )}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        {formatMessage({ id: 'epiChat.conceptGroupPreview.skipped.description' })}
      </Typography>
      <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
        {values.map((value, index) => (
          <Chip
            key={`${value}-${index}`}
            size="small"
            variant="outlined"
            label={value}
            // Explicit high-contrast styling: a white pill with a red border and
            // dark-red label. The default error Chip renders a solid red fill here
            // (theme override) which hid the value text entirely.
            sx={{
              backgroundColor: 'background.paper',
              borderColor: 'error.main',
              color: 'error.dark',
              fontWeight: 600,
              '& .MuiChip-label': { color: 'error.dark' },
            }}
          />
        ))}
      </Stack>
    </Alert>
  );
};
